import checkPricesConstants from "./constants"

const initialState = {
	//FirstStep
	dataEntry      : {},
	error          : null,
	isFirstSending : false,
	isFileSending  : false,

	//SecondStep
	secondStepSending     : false,
	isCreatingReOrgAccess : true,
	allowChanged          : null,

	//FourthStep
	fourthStepSending : false,
	paged             : {},

	//createPeriodAccessForReOrgs
	createPeriodAccessForReorgsResult: false,

	//getPagedReOrgsPeriodAccess
	reOrgsPeriodAccess: {},

	//getPagedReOrgConstructionMaterialsPeriodAccess
	reOrgConstractionMaterialsPeriodAccessAllowed    : {},
	reOrgConstractionMaterialsPeriodAccessNotAllowed : {},

	//sendNotification
	sendNotificationResult : null,
	notificationSending    : false
}

export default function (state = initialState, action){
	switch (action.type){
		case (checkPricesConstants.CHECK_DATA_ENTRY.REQUEST):
			return {
				...state,
				sendNotificationResult : null,
				isFirstSending         : true
			}
		case (checkPricesConstants.CHECK_DATA_ENTRY.SUCCESS):
			return {
				...state,
				dataEntry      : action.payload.result,
				isFirstSending : false
			}
		case (checkPricesConstants.CHECK_DATA_ENTRY.FAILURE):
			return {
				...state,
				error          : action.payload,
				isFirstSending : false
			}
		case (checkPricesConstants.DownloadFileWithMaterials.REQUEST): {
			return {
				...state,
				isFileSending: true
			}
		}
		case (checkPricesConstants.DownloadFileWithMaterials.SUCCESS):
		case (checkPricesConstants.DownloadFileWithMaterials.FAILURE): {
			return {
				...state,
				isFileSending: false
			}
		}

		//SecondStep

		//createPeriodAccessForReOrgs
		case (checkPricesConstants.CREATE_PERIOD_ACCESS_FOR_REORGS.REQUEST):
			return {
				...state,
				allowChanged                      : null,
				createPeriodAccessForReorgsResult : false,
				sendNotificationResult            : null,
				secondStepSending                 : true,
				isCreatingReOrgAccess             : true
			}
		case (checkPricesConstants.CREATE_PERIOD_ACCESS_FOR_REORGS.SUCCESS):
			return {
				...state,
				createPeriodAccessForReorgsResult : action.payload.result,
				isCreatingReOrgAccess             : false,
				secondStepSending                 : false
			}
		case (checkPricesConstants.CREATE_PERIOD_ACCESS_FOR_REORGS.FAILURE):
			return {
				...state,
				error             : action.payload,
				secondStepSending : false
			}

			//getPagedReOrgsPeriodAccess
		case (checkPricesConstants.GET_PAGED_REORGS_PERIOD_ACCESS.REQUEST):
			return {
				...state,
				allowChanged       : null,
				reOrgsPeriodAccess : null,
				secondStepSending  : true
			}
		case (checkPricesConstants.GET_PAGED_REORGS_PERIOD_ACCESS.SUCCESS):
			return {
				...state,
				reOrgsPeriodAccess : action.payload.result,
				secondStepSending  : false
			}
		case (checkPricesConstants.GET_PAGED_REORGS_PERIOD_ACCESS.FAILURE):
			return {
				...state,
				error             : action.payload,
				secondStepSending : false
			}

			//getPagedReOrgConstructionMaterialsPeriodAccessAllowed
		case (checkPricesConstants.GET_PAGED_REORG_CONSTRACTION_MATERIALS_PERIOD_ACCESS_ALLOWED.REQUEST):
			return {
				...state,
				allowChanged      : null,
				secondStepSending : true
			}
		case (checkPricesConstants.GET_PAGED_REORG_CONSTRACTION_MATERIALS_PERIOD_ACCESS_ALLOWED.SUCCESS):
			return {
				...state,
				reOrgConstractionMaterialsPeriodAccessAllowed : action.payload.result,
				secondStepSending                             : false
			}
		case (checkPricesConstants.GET_PAGED_REORG_CONSTRACTION_MATERIALS_PERIOD_ACCESS_ALLOWED.FAILURE):
			return {
				...state,
				error             : action.payload,
				secondStepSending : false
			}

			//getPagedReOrgConstructionMaterialsPeriodAccessNotAllowed
		case (checkPricesConstants.GET_PAGED_REORG_CONSTRACTION_MATERIALS_PERIOD_ACCESS_NOT_ALLOWED.REQUEST):
			return {
				...state,
				allowChanged      : null,
				secondStepSending : true
			}
		case (checkPricesConstants.GET_PAGED_REORG_CONSTRACTION_MATERIALS_PERIOD_ACCESS_NOT_ALLOWED.SUCCESS):
			return {
				...state,
				reOrgConstractionMaterialsPeriodAccessNotAllowed : action.payload.result,
				secondStepSending                                : false
			}
		case (checkPricesConstants.GET_PAGED_REORG_CONSTRACTION_MATERIALS_PERIOD_ACCESS_NOT_ALLOWED.FAILURE):
			return {
				...state,
				error             : action.payload,
				secondStepSending : false
			}

		case (checkPricesConstants.ALLOW_PERIOD_ACCESS_FOR_ALL.REQUEST):
		case (checkPricesConstants.ALLOW_PERIOD_ACCESS_FOR_REORGS.REQUEST):
		case (checkPricesConstants.ALLOW_PERIOD_ACCESS_FOR_REORG_MATERIALS.REQUEST):
			return {
				...state,
				secondStepSending : true,
				allowChanged      : null
			}
		case (checkPricesConstants.ALLOW_PERIOD_ACCESS_FOR_ALL.SUCCESS):
		case (checkPricesConstants.ALLOW_PERIOD_ACCESS_FOR_REORGS.SUCCESS):
		case (checkPricesConstants.ALLOW_PERIOD_ACCESS_FOR_REORG_MATERIALS.SUCCESS):
			return {
				...state,
				allowChanged      : action.payload.result ? "Доступ успешно открыт." : null,
				secondStepSending : false
			}
		case (checkPricesConstants.ALLOW_PERIOD_ACCESS_FOR_ALL.FAILURE):
		case (checkPricesConstants.ALLOW_PERIOD_ACCESS_FOR_REORGS.FAILURE):
		case (checkPricesConstants.ALLOW_PERIOD_ACCESS_FOR_REORG_MATERIALS.FAILURE):
			return {
				...state,
				error             : action.payload,
				secondStepSending : false
			}

		//sendNotification
			//getPagedReOrgConstructionMaterialsPeriodAccessNotAllowed
		case (checkPricesConstants.SEND_NOTIFICATION_TO_REORG.REQUEST):
			return {
				...state,
				sendNotificationResult : null,
				notificationSending    : true
			}
		case (checkPricesConstants.SEND_NOTIFICATION_TO_REORG.SUCCESS):
			return {
				...state,
				sendNotificationResult : action.payload.result ? "Уведомление успешно отправлено." : null,
				notificationSending    : false
			}
		case (checkPricesConstants.SEND_NOTIFICATION_TO_REORG.FAILURE):
			return {
				...state,
				error               : action.payload,
				notificationSending : false
			}
		case checkPricesConstants.CLEAR_STEP_STORE :{
			return {
				...initialState
			}
		}

		//FourthStep

		case (checkPricesConstants.COMPARE_PRICES.REQUEST):
			return {
				...state,
				fourthStepSending: true
			}
		case (checkPricesConstants.COMPARE_PRICES.SUCCESS):
			return {
				...state,
				paged             : action.payload.result,
				fourthStepSending : false
			}
		case (checkPricesConstants.COMPARE_PRICES.FAILURE):
			return {
				...state,
				error             : action.payload,
				fourthStepSending : false
			}

		default:
			return state
	}
}